import { Grid, Typography } from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../assets/css/header.css";
import "../assets/css/icon.css";
import { service } from "../model";

const Header = ({ user }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    const isDetailPage =
      location.pathname.startsWith("/aml/") &&
      ![
        "/aml/moduli-in-raccolta",
        "/aml/moduli-scaduti",
        "/aml/moduli-validi",
        "/aml/ricerca-moduli",
      ].includes(location.pathname);

    if (isDetailPage) {
      navigate(-1);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      await service.logout(token);
    } catch (err) {
      console.error("Errore logout:", err.message);
    } finally {
      localStorage.removeItem("token");
      window.location.href = process.env.REACT_APP_RETURN_LEXIA_TOOLS;
    }
  };

  const getTitle = () => {
    return "AML Dashboard Admin";
  };

  return (
    <Grid
      container
      className="bg-blue-dark"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "5px 0px",
        alignItems: "center",
        height: "90px",
      }}
    >
      {/* icona logout/back */}
      <Grid
        item
        xs={2}
        md={0.5}
        style={{
          display: "flex",
          justifyContent: "start",
          marginLeft: "0px",
        }}
      >
        <div
          onClick={handleLogout}
          className="icon-logout container-icon"
          aria-label="Logout"
          style={{ cursor: "pointer" }}
        ></div>
      </Grid>

      {/* titolo */}
      <Grid
        item
        xs={8}
        md={10.5}
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Typography className="color-light title-header">Centro AML</Typography>
      </Grid>

      {/* logo */}
      <Grid
        item
        xs={2}
        md={0.5}
        style={{
          display: "flex",
          justifyContent: "end",
        }}
      >
        <div className="logo-lexia-header" />
      </Grid>
    </Grid>
  );
};

export default Header;
